var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.ProfileKeywordSettingTable,{on:{"add":_setup.onAdd,"edit":_setup.onEdit,"copy":_setup.onCopy}}),_vm._v(" "),_c(_setup.DialogProfileKeywordSetting,{ref:"dialogProfileKeywordSettingRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }